import React from "react";
import { localizer } from '../../Translator'

import Grid from '@material-ui/core/Grid';
import { TextFieldStyled } from "../common/InputStyled";
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import InputAdornment from '@material-ui/core/InputAdornment'
import Typography from '@material-ui/core/Typography'

import { PassStrength } from './PassStrength'

import ScreenHeading from "../common/ScreenHeading.js";

import { SnackbarCustom } from "../Utilities/SnackbarCustom";

import AuthCli from "../../sdk/AuthCli";


export class ReplacePassword extends React.Component {

  constructor(props) {
    super(props)
    this.state = {

      credentials: {
        // E-mail address user unique identifier.
        userEmail: '',
        // Controlled for current password field
        currentPassword: '',
        // Controlled form field.
        newPassword: '',
      },
      // Controlled form field.
      newPassword: '',

       
      // Controlled form field.
      newPasswordRepeat: '',

      // Indicates that the currently typed password would be accepted by the service (determined externally).
      passwordAttemptValidated: false,

      // Pass through password as being typed by the user.
      passwordAttempt: '',

      // Result of checking validity of the password being typed.
      //passwordAttemptValidated: false,

      // Used to wait until the desired language is loaded.
      isLoading: false,

      replacePasswordError: null,
      replacePasswordSuccess: null

    }
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const userEmail = queryParams.get('userEmail') !== null ? queryParams.get('userEmail') : ""

    this.setState(previousState => ({
      credentials: {
        ...previousState.credentials,
        userEmail: userEmail.toLowerCase()
      }
    }), () => {
      AuthCli.GetSessionInfo().then(session => {
        if (session) {
          //this.setState({credentials.userEmail: session.userEmail.toLowerCase()})
          this.setState(previousState => ({
            credentials: {
              ...previousState.credentials,
              userEmail: session.userEmail.toLowerCase()
            }
          }))
        }
      })
    })
  }
  
  /**
  * Controlled fields refresh.
  */
  handleFieldChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'newPasswordRepeat') {
      this.setState({ [name]: value })
    } else {
      this.setState(previousState => ({
        credentials: {
          ...previousState.credentials,
          [name]: value
        },
      }))
    }
  }

  /**
   * Submit replace password request
   */
  handleReplacePasswordRequest = () => {
    
    AuthCli.ReplacePassword(this.state.credentials).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ replacePasswordError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState(previousState => ({
          credentials: {
            ...previousState.credentials,
            userEmail: "",
            currentPassword: "",
            newPassword: ""
          },
          newPasswordRepeat: "",
          replacePasswordSuccess: localizer.ReplacePasswordSuccess,
        }))
      }
    })

  }

  handleonClose = () => {
    this.setState({ replacePasswordError: null, replacePasswordSuccess: null })
  }

  render() {

    const isLoading = this.state.isLoading
    const mismatch = this.state.newPassword && this.state.newPasswordRepeat && this.state.newPassword !== this.state.newPasswordRepeat
    const invalid = !this.state.newPasswordRepeat || mismatch || !this.state.passwordAttemptValidated

    return (
      
      <React.Fragment>
        
        <Container>
          {/* Screen heading title. */}
          {/*           <GridHeaderComponent container direction="row">
            <Grid item md={12}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-unlock-keyhole icon-button-header mr-10"></i>{localizer.WelcomeReplacePassword}</Typography>
            </Grid>
          </GridHeaderComponent> */}

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-unlock-keyhole icon-button-header mr-20 ml-20"></i>} title={localizer.WelcomeReplacePassword} />

          <Grid container direction="row" justify="center" alignItems="center" alignContent="center" className="container-generic">
            <Grid item md={12}>
              <Typography className="typography-generic">{localizer.ReplacePasswordDescription}</Typography>
            </Grid>
            {/* Form to type password and confirm. */}
            <Grid item xs={12} md={6} >
              <Paper elevation={2} style={{ height: "350px", marginRight: "10px" }}>
                <Grid container>
                  <Grid item xs={12} className="p-20">
                    {/* E-mail address, user unique identifier for sign up. */}
                    <TextFieldStyled
                      variant="outlined"
                      placeholder={localizer.UserEmail}
                      name="userEmail"
                      value={this.state.credentials.userEmail}
                      onChange={(e) => { this.handleFieldChange(e); }}
                      fullWidth
                      inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-user" />
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} className="p-20">
                    {/* Current password. */}
                    <TextFieldStyled
                      variant="outlined"
                      label={<Typography className="typography-generic" variant="caption">{localizer.SignupCurrentPassword}</Typography>}
                      placeholder={localizer.SignupCurrentPassword}
                      name="currentPassword"
                      type="password"
                      value={this.state.credentials.currentPassword}
                      onChange={(e) => { this.handleFieldChange(e); }}
                      fullWidth
                      inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-key"></i>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} className="p-20">
                    {/* New password, first typing. */}
                    <TextFieldStyled
                      variant="outlined"
                      label={<Typography className="typography-generic" variant="caption">{localizer.SignupPassword}</Typography>}
                      placeholder={localizer.SignupPassword}
                      name="newPassword"
                      type="password"
                      value={this.state.credentials.newPassword}
                      onChange={(e) => { this.handleFieldChange(e); this.setState({ passwordAttempt: e.target.value, newPassword: e.target.value }) }}
                      fullWidth
                      inputRef={(input) => { if (input != null && this.initialFocus) { input.focus(); this.initialFocus = false } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-key"></i>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} className="p-20">
                    {/* New password, repeated. */}
                    <TextFieldStyled
                      error={mismatch || null}
                      helperText={<Typography className="typography-generic" variant="caption">{mismatch ? localizer.PasswordsMismatch : " "}</Typography>}
                      variant="outlined"
                      label={<Typography className="typography-generic" variant="caption">{localizer.SignupPasswordRepeat}</Typography>}
                      placeholder={localizer.SignupPassword}
                      name="newPasswordRepeat"
                      type="password"
                      value={this.state.newPasswordRepeat}
                      onChange={this.handleFieldChange}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fa-solid fa-key"></i>
                          </InputAdornment>
                        ),
                        classes: {
                          input: "typography-generic"
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Helper for password strongness. */}
            <Grid item xs={12} md={6} className="p-10">
              <PassStrength
                passwordAttempt={this.state.passwordAttempt}
                onValidationChange={(isValidated) => { this.setState({ passwordAttemptValidated: isValidated }) }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              {/* Confirmation button. */}
              <Button
                className="button-generic"
                variant="contained"
                color="secondary"
                fullWidth
                disabled={isLoading || invalid}
                onClick={this.handleReplacePasswordRequest}>{localizer.ReplacePassword}
              </Button>

            </Grid>
          </Grid>

         
        </Container>

        {/* Replace password error. */}
        <SnackbarCustom message={this.state.replacePasswordError} severity="error" handleonClose={this.handleonClose} />
       
        {/* Replace password success confirmation. */}
        <SnackbarCustom message={this.state.replacePasswordSuccess} severity="success" handleonClose={this.handleonClose} />
       
        {/* Waiting for language load when entering the screen. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/password/ReplacePassword.js